/**
 * DJI México - Header 与搜索链路埋点（全站）
 * ==================================================================
 * 严格按《数据埋点定义文档》Header 实施清单表（H1-01–H1-07、S1–S7）实施。
 * Header 表管全站：三页都发送，来源差异由 page_type 区分。
 *
 *   H1-01 Logo              logo_click              L3
 *   H1-02 导航展开          nav_menu_open           L3
 *   H1-03 导航跳转          nav_click               L3
 *   H1-04 搜索图标          site_search_open        L3
 *   S1    关键词建议        search_suggestion_click L3
 *   S2    商品建议（零输入）search_select_item      L1/L2
 *   S3    提交搜索          search_submit           L3
 *   S4    结果渲染          view_search_results     L2
 *   S5    无结果            search_no_results       L2
 *   S6    结果商品曝光      view_item_list          L1/L2
 *   S7    结果商品点击      select_item             L1
 *   H1-05 账户入口          account_entry_click     L3
 *   H1-06 购物车入口        cart_entry_click        L1/L3
 *   H1-07 购物车实际展示    view_cart               L1
 */
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  var C = {
    logo:      { component_id: 'header_logo',                placement: 'header_left' },
    nav:       { component_id: 'header_nav',                 placement: 'header_primary' },
    search:    { component_id: 'header_search',              placement: 'header_right' },
    suggest:   { component_id: 'search_suggestions',         placement: 'search_drawer' },
    suggestPd: { component_id: 'search_product_suggestions', placement: 'search_drawer' },
    siteSearch:{ component_id: 'site_search',                placement: 'search_drawer' },
    results:   { component_id: 'search_results',             placement: 'search_results' },
    resultGrid:{ component_id: 'search_results_grid',        placement: 'search_results' },
    account:   { component_id: 'header_account',             placement: 'header_right' },
    cart:      { component_id: 'header_cart',                placement: 'header_right' }
  };

  var SEL = {
    logo:        'a.header-logo',
    /* ⚠️ 线上实测：主题自带的 a.header-menu-link / li.header-menu-item /
       .mega-menu-container / ul.mega-menu-item-inner / .mega-menu-link-main
       在真实页面上**全部 0 命中** —— 导航由 tmenu 应用运行时渲染：
         div.tmenu_wrapper > nav.tmenu_navbar > ul.tmenu_nav
           > li.tmenu_item.tmenu_item--root.tmenu_item_level_0
             > a.tmenu_item_link > span.tmenu_item_text
       层级写在 class 里（tmenu_item_level_0/1/2/3），子面板是 ul.tmenu_submenu_type_*。
       两套选择器都保留：应用若被卸载，主题版本自动兜底。 */
    navRootLink: 'a.tmenu_item_link, a.header-menu-link',
    navLink:     'a.tmenu_item_link, a.header-menu-link, .mega-menu-container a, .mega-menu-item a',
    navText:     'span.tmenu_item_text',
    navSubmenu:  'ul[class*="tmenu_submenu"], .mega-menu-wrapper, .mega-menu-container',
    navItem:     'li.tmenu_item--root, li.header-menu-item',
    mobileLink:  '[mobile-drawer-content] a, .mobile-menu-submenu a, mobile-menu a',
    searchPopup: '#glFilter-search-popup',
    searchInput: '#gl-d-searchbox-input',
    searchForm:  '.gl-d-searchbox, form[action*="/search"]',
    /* 实测：a.gl-focusable-item[href*="/search"] ✅ 3；
       .gl-recent-searches 与 .gl-fullscreen-top-searches 均为 0 命中，
       真实容器是 .gl-popular-search-terms / .gl-fullscreen-top-clicked。 */
    suggestion:  'a.gl-focusable-item[href*="/search"], .gl-popular-search-terms a, .gl-popular-search-term-item, .gl-fullscreen-top-clicked a',
    productCard: '.gl-product-card',
    resultsWrap: '.gl-fullscreen-results__content, #gl-search-listbox',
    /* ⚠️ 结果页 /search?q= 与抽屉是两套 DOM：实测结果页上
       #glFilter-search-popup / .gl-product-card 均为 0，
       用的是主题的 .collection-products-list + .product-card。 */
    pageResults: '.collection-products-list, #product-grid, [id*="ProductGridContainer"]',
    pageCard:    '.product-card, product-card, .card-wrapper, .grid__item',
    /* The active Header marks its account control explicitly; retain legacy
       customer-authentication and /account paths for compatibility. */
    account:     'shopify-account, [data-header-account-trigger], a.header-icon-link[href*="/customer_authentication"], a[href*="/account"]',
    searchIcon:  '[data-header-search-trigger], button.header-icon-link[aria-label="Buscar"], a.header-icon-link[href*="/search"], header [aria-label="Buscar"], header [aria-label="Search"]',
    cartTrigger: '[data-header-cart-trigger]',
    cartDrawer:  'cart-drawer, [drawer-minicart]'
  };

  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }
  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }

  function base(cfg, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component_id: cfg.component_id,
      placement: cfg.placement
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  /** 从 URL 推导导航项标识，不用西语展示文案当 ID */
  function navItemId(href) {
    if (!href) return undefined;
    var m = String(href).match(/\/(collections|products|pages|blogs)\/([^/?#]+)/);
    if (m) return m[1].replace(/s$/, '') + ':' + m[2];
    if (/\/apps\//.test(href)) return 'app:' + (String(href).split('/apps/')[1] || '').split(/[/?#]/)[0];
    return undefined;
  }

  var LV_RE = /tmenu_item_level_(\d+)/;

  /** 由 tmenu 的 level class 推层级（level_0 即一级）；表格只定义到三级，更深的并入三级 */
  function navLevel(a) {
    var li = a.closest('li.tmenu_item');
    if (li) {
      var m = String(li.className || '').match(LV_RE);
      if (m) return Math.min(3, parseInt(m[1], 10) + 1);
    }
    if (a.closest('ul.mega-menu-item-inner')) return 3;
    if (a.closest('.mega-menu-container, .mega-menu-item')) return 2;
    return 1;
  }

  /** 上一级可跳转项的 id：从当前 li 的父容器再往上找一个 li */
  function parentNavId(a) {
    var li = a.closest('li.tmenu_item, li.header-menu-item');
    var up = li && li.parentNode && li.parentNode.closest
      ? li.parentNode.closest('li.tmenu_item, li.header-menu-item') : null;
    var link = up ? up.querySelector(SEL.navRootLink) : null;
    if (!link) {
      var wrap = a.closest('.mega-menu-item-wrapper');
      if (wrap) link = wrap.querySelector('.mega-menu-link-main');
    }
    return navItemId(link && link.getAttribute('href'));
  }

  /** tmenu 把文案包在 span.tmenu_item_text 里，直接取 innerText 会带上角标/箭头 */
  function navName(a) {
    var s = a.querySelector(SEL.navText);
    return txt(s) || txt(a);
  }

  function cartType() {
    return (DL.ctx.cart_type === 'drawer' || DL.ctx.cart_type === 'notification') ? 'drawer' : 'page';
  }

  /* ============ H1-01 / H1-03 / H1-05 / H1-06 点击委托 ============ */

  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;

    var logo = t.closest(SEL.logo);
    if (logo) {
      DL.afterTick(function () {
        var __np = DL.navPush(evt, logo);
        if (!__np) return;
        __np('logo_click', base(C.logo, { destination_url: logo.getAttribute('href') || undefined }));
      });
      return;
    }

    /* H1-03 nav_click —— 一/二/三级统一走一个分支，层级由 DOM 结构推导 */
    var navA = t.closest(SEL.navLink);
    if (navA && navA.getAttribute('href')) {
      var lv  = navLevel(navA);
      var pid = parentNavId(navA);
      DL.afterTick(function () {
        var __np = DL.navPush(evt, navA);
        if (!__np) return;
        var href = navA.getAttribute('href');
        __np('nav_click', base(C.nav, {
          nav_level: lv,
          nav_item_id: navItemId(href),
          nav_item_name: navName(navA),
          parent_nav_item_id: pid,
          destination_url: href || undefined
        }));
      });
      return;
    }

    var mob = t.closest(SEL.mobileLink);
    if (mob) {
      DL.afterTick(function () {
        var __np = DL.navPush(evt, mob);
        if (!__np) return;
        var href = mob.getAttribute('href');
        __np('nav_click', base(C.nav, {
          nav_level: 1,
          nav_item_id: navItemId(href),
          nav_item_name: txt(mob),
          destination_url: href || undefined
        }));
      });
      return;
    }

    var acc = t.closest(SEL.account);
    /* ⚠️ 不限作用域的话，移动端抽屉、Footer、订单页里任何指向 /account 的链接
       都会被记成 Header 账户入口（component_id=header_account），来源字段失真。 */
    if (acc && !acc.matches('shopify-account') &&
        !acc.closest('.header-right, [class*="header-"], header, #shopify-section-header')) acc = null;
    if (acc) {
      DL.afterTick(function () {
        if (!DL.isInteractive(acc)) return;
        DL.push('account_entry_click', base(C.account, {
          destination_url: (acc.getAttribute && acc.getAttribute('href')) || undefined,
          login_state: DL.ctx.customer_logged_in ? 'logged_in' : 'guest'
        }));
      });
      return;
    }

    var cartBtn = t.closest(SEL.cartTrigger);
    if (cartBtn) {
      DL.afterTick(function () {
        if (!DL.isInteractive(cartBtn)) return;
        DL.push('cart_entry_click', base(C.cart, { cart_type: cartType() }));
      });
    }
  }, true);

  /* ============ H1-02 nav_menu_open ============ */
  /* 表格：桌面 hover 需停留 >=300ms；移动端以点击展开为准；重复展开同项不重发 */

  function initNavMenuOpen() {
    var opened = {};

    /* ⚠️ 实测 tmenu 在 hover 时**不改动任何 class**（纯 CSS :hover 控制），
       靠 class 判断展开会一个都发不出来 —— 只能改判面板的真实可见性。 */
    function panelOpen(item) {
      /* 实测 tmenu 展开时给 li 加的是 tmenu_item_active */
      if (item.classList.contains('open') || item.classList.contains('tmenu_item_active')) return true;
      var p = item.querySelector(SEL.navSubmenu);
      if (!p || p.hasAttribute('hidden')) return false;
      var cs = w.getComputedStyle(p);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity || '1') < 0.1) return false;
      var r = p.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function emit(item, method) {
      var link = item.querySelector(SEL.navRootLink);
      var key = navItemId(link && link.getAttribute('href')) || (link ? navName(link) : '');
      if (!key || opened[key]) return;
      opened[key] = 1;
      DL.push('nav_menu_open', base(C.nav, {
        nav_level: 1,
        nav_item_id: navItemId(link && link.getAttribute('href')),
        nav_item_name: link ? navName(link) : undefined,
        interaction_method: method
      }));
    }

    /* ⚠️ 不能在 init 时逐项 addEventListener —— tmenu 是应用运行时注入导航的，
       实测同一份代码两次运行结果不一致（一次 0 事件、一次正常），就是这个竞态。
       改成 document 委托：无论导航何时渲染出来都能接住。 */
    var hoverItem = null, hoverTimer = null;

    d.addEventListener('mouseover', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || item === hoverItem) return;
      if (!item.querySelector(SEL.navSubmenu)) return;
      hoverItem = item;
      if (hoverTimer) w.clearTimeout(hoverTimer);
      /* ⚠️ 表格要求「停留≥300ms」，但实测面板从 hover 到真正可见还要再等一会儿
         （CSS 过渡 + 应用自身延时）。只查一次会在 300ms 那一帧看到 hidden 就此作罢，
         线上表现为 hover 永远不上报。改成 300ms 起开始轮询，最多再等 1.2s。 */
      var waited = 0;
      hoverTimer = w.setTimeout(function poll() {
        if (hoverItem !== item) return;
        if (panelOpen(item)) { emit(item, 'hover'); return; }
        waited += 100;
        if (waited > 1200) return;
        hoverTimer = w.setTimeout(poll, 100);
      }, 300);
    }, true);

    d.addEventListener('mouseout', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || item !== hoverItem) return;
      /* 在同一项内部移动会不断触发 mouseout，只有真的移出去才算离开 */
      var to = evt.relatedTarget;
      if (to && to.closest && to.closest(SEL.navItem) === item) return;
      hoverItem = null;
      if (hoverTimer) { w.clearTimeout(hoverTimer); hoverTimer = null; }
    }, true);

    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || !item.querySelector(SEL.navSubmenu)) return;
      w.setTimeout(function () { if (panelOpen(item)) emit(item, 'click'); }, 120);
    }, true);
  }

  /* ============ 搜索链路 S1–S7 ============ */

  var searchState = { queryId: null, term: '', method: null, reported: {} };
  var batchIndex = 0;

  var QID_KEY = 'dji_search_qid';

  function newQueryId() {
    searchState.queryId = DL.uuid();
    searchState.reported = {};
    return searchState.queryId;
  }

  /**
   * ⚠️ query_id 必须跨「抽屉 → 结果页」的整页跳转延续，否则
   * search_submit / view_search_results / view_item_list / select_item
   * 会分裂成两个不相关的 query_id，「搜了什么→看到什么→点了什么」串不起来。
   */
  function stashQueryId(term, method) {
    try {
      w.sessionStorage.setItem(QID_KEY, JSON.stringify({
        qid: searchState.queryId, term: String(term || ''),
        /* ⚠️ method 也要一起存：它只活在内存里，整页跳转后必然丢失，
           不存的话结果页只能恒报 'enter'，点关键词建议进来的贡献完全看不见。 */
        method: method || searchState.method || null,
        at: Date.now()
      }));
    } catch (e) {}
  }

  function adoptQueryId(term) {
    var rec = null;
    try { rec = JSON.parse(w.sessionStorage.getItem(QID_KEY) || 'null'); } catch (e) {}
    if (!rec || !rec.qid) return null;
    if (Date.now() - (rec.at || 0) > 120000) return null;
    if (String(rec.term || '') !== String(term || '')) return null;   /* 换了词就是新一次搜索 */
    searchState.queryId = rec.qid;
    return rec.qid;
  }

  function clearStashedQueryId() {
    try { w.sessionStorage.removeItem(QID_KEY); } catch (e) {}
  }

  function popup() {
    var p = d.querySelector(SEL.searchPopup);
    if (!p) return null;
    var r = p.getBoundingClientRect(), s = w.getComputedStyle(p);
    if (s.display === 'none' || s.visibility === 'hidden' || r.height === 0) return null;
    return p;
  }

  function currentTerm() {
    var i = d.querySelector(SEL.searchInput) || d.querySelector(SEL.searchPopup + ' input[name="q"]');
    return i ? String(i.value || '').trim() : '';
  }

  function resultCards(p) { return all(p || d, SEL.productCard); }

  function resultsCount(p) {
    var meta = (p || d).querySelector('.gl-fullscreen-results__meta, [data-total-results]');
    if (meta) {
      var attr = meta.getAttribute && meta.getAttribute('data-total-results');
      if (attr && !isNaN(attr)) return Number(attr);
      var m = String(meta.innerText || '').replace(/[.,]/g, '').match(/(\d+)/);
      if (m) return Number(m[1]);
    }
    return resultCards(p).length;
  }

  function searchItem(card, index) {
    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var title = txt(card.querySelector('[class*="title"]')) ||
      String((link && link.getAttribute('aria-label')) || '').replace(/^[^:]*:\s*/, '').slice(0, 80);
    return DL.clean({
      item_id: card.getAttribute('data-product-id') ||
               ((card.querySelector('[data-product-id]') || {}).getAttribute
                 ? card.querySelector('[data-product-id]').getAttribute('data-product-id') : undefined),
      item_name: title || undefined,
      item_brand: DL.ctx.brand || 'DJI',
      product_handle: (String(href).match(/\/products\/([^/?#]+)/) || [])[1],
      quantity: 1,
      item_list_id: 'search_results',
      item_list_name: 'Search Results',
      index: index
    });
  }

  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  var resultsTimer = null;

  function watchResults(p) {
    if (!p) return;
    if (watched) { if (watched.has(p)) return; watched.add(p); }
    var mo = new MutationObserver(function () {
      if (resultsTimer) w.clearTimeout(resultsTimer);
      resultsTimer = w.setTimeout(function () { evaluateResults(p); }, 600);
    });
    mo.observe(p, { childList: true, subtree: true, characterData: true });
  }

  function evaluateResults(p) {
    if (!popup()) return;
    var term = currentTerm();
    if (!term || term.length < 2) return;
    var safe = DL.sanitize(term);
    if (!safe) return;

    if (safe !== searchState.term) {
      searchState.term = safe;
      newQueryId();
      batchIndex = 0;
    }
    var qid = searchState.queryId;
    var count = resultsCount(p);

    /* S4 结果容器渲染完成，query_id 与 results_count 已确定 */
    if (!searchState.reported.view) {
      searchState.reported.view = 1;
      DL.push('view_search_results', base(C.results, {
        query_id: qid,
        search_term_sanitized: safe,
        results_count: count,
        current_filters: '',
        current_sort: ''
      }));
    }

    /* S5 无结果 */
    if (count === 0) {
      if (!searchState.reported.none) {
        searchState.reported.none = 1;
        DL.push('search_no_results', base(C.results, {
          query_id: qid,
          search_term_sanitized: safe,
          search_method: searchState.method || 'enter',
          results_count: 0
        }));
      }
      return;
    }

    /* S6 结果商品曝光：可见>=50% 持续>=1s，按批次去重 */
    var wrap = p.querySelector(SEL.resultsWrap);
    if (!wrap || !resultCards(p).length) return;
    batchIndex += 1;
    var thisBatch = batchIndex;
    DL.observe(wrap, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      if (!DL.once('view_item_list|search|' + qid + '|' + thisBatch)) return;
      /* index 全站统一 1 起（collection / home / 结果页都是 1 起），
         原来是 0 起，会让「列表第 N 位点击率」在下拉与列表页之间差一位 */
      var items = resultCards(p).map(function (c, i) { return searchItem(c, i + 1); });
      if (!items.length) return;
      DL.push('view_item_list', base(C.resultGrid, {
        item_list_id: 'search_results',
        item_list_name: 'Search Results',
        query_id: qid,
        list_batch_index: thisBatch,
        current_filters: '',
        current_sort: '',
        exposure_rule: meta && meta.rule,
        items: items
      }));
    });
  }

  /* S1 关键词建议 / S2 零输入商品建议 / S7 结果商品点击 */
  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var p = t.closest(SEL.searchPopup);
    if (!p) return;

    var card = t.closest(SEL.productCard);
    if (card) {
      var cards = resultCards(p);
      var idx = cards.indexOf(card);
      var link = t.closest('a[href]') || card.querySelector('a[href]');
      var item = searchItem(card, idx > -1 ? idx + 1 : undefined);
      var isZeroState = !currentTerm();
      DL.afterTick(function () {
        /* 卡片本身可能不是 <a>（整卡由 JS 跳转），此时没有链接可判定，
           退回直接发送；有链接就走「确认真实跳转」的代理。 */
        var __np = link ? DL.navPush(evt, link) : DL.push;
        if (!__np) return;
        if (isZeroState) {
          __np('search_select_item', base(C.suggestPd, {
            item_list_id: 'search_suggestions_zero',
            item_list_name: 'Search Zero-state Suggestions',
            index: idx > -1 ? idx + 1 : undefined,
            items: [item]
          }));
        } else {
          __np('select_item', base(C.resultGrid, {
            item_list_id: 'search_results',
            item_list_name: 'Search Results',
            query_id: searchState.queryId,
            index: idx > -1 ? idx + 1 : undefined,
            destination_url: link ? link.getAttribute('href') : undefined,
            items: [item]
          }));
        }
      });
      return;
    }

    var sug = t.closest(SEL.suggestion);
    if (sug) {
      var href = sug.getAttribute('href') || '';
      var qm = href.match(/[?&]q=([^&]*)/);
      var word = qm ? decodeURIComponent(qm[1].replace(/\+/g, ' ')) : txt(sug);
      var sugs = all(p, SEL.suggestion);
      var sIdx = sugs.indexOf(sug);
      searchState.method = 'keyword_suggestion';
      /* ⚠️ 点建议是 click 不是 submit，走不到 submit 监听 ——
         必须在这里 stash，否则 query_id 与 search_method 都会在跳转后断链。 */
      if (!searchState.queryId) newQueryId();
      stashQueryId(currentTerm() || txt(sug), 'keyword_suggestion');
      DL.afterTick(function () {
        var __np = DL.navPush(evt, sug);
        if (!__np) return;
        __np('search_suggestion_click', base(C.suggest, {
          suggestion_type: 'keyword',
          suggestion_id: DL.sanitize(word),
          suggestion_text: DL.sanitize(word),
          suggestion_index: sIdx > -1 ? sIdx + 1 : undefined,
          search_method: 'keyword_suggestion'
        }));
      });
    }
  }, true);

  /* H1-04 site_search_open */
  function initSearchOpen() {
    var isOpen = false;
    var mo = new MutationObserver(function () {
      var p = popup();
      if (p && !isOpen) {
        isOpen = true;
        newQueryId();
        clearSearchOpenIntent();   /* 已经以抽屉形态发过，不能再以 page 形态发一次 */
        DL.push('site_search_open', base(C.search, { search_surface: 'drawer' }));
      } else if (!p && isOpen) {
        isOpen = false;
      }
      if (p) watchResults(p);
    });
    mo.observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    /* ⚠️ 结果页不能无条件补发。
       表格口径是「**点击搜索图标**且搜索抽屉/搜索页实际可见」，
       上一版只要 page_type=search 就发一条 search_surface=page ——
       从导航、外链、书签、刷新进结果页都会凭空多出一条「用户打开了搜索」，
       违反「页面初始渲染不得伪造成用户主动事件」。
       改成只认「本次是点搜索图标跳过来的」：点击时打标，结果页消费。 */
    if (DL.ctx.page_type === 'search' && DL.ctx.search && consumeSearchOpenIntent()) {
      newQueryId();
      if (DL.onceSession('site_search_open|' + (searchState.queryId || ''))) {
        DL.push('site_search_open', base(C.search, { search_surface: 'page' }));
      }
    }
  }

  /* 搜索图标点击意图：仅用于区分「图标开抽屉」还是「图标跳搜索页」 */
  var OPEN_KEY = 'dji_search_open_intent';

  function markSearchOpenIntent() {
    try { w.sessionStorage.setItem(OPEN_KEY, String(DL.now ? DL.now() : +new Date())); } catch (e) {}
  }

  function clearSearchOpenIntent() {
    try { w.sessionStorage.removeItem(OPEN_KEY); } catch (e) {}
  }

  /** 10 秒内点过搜索图标才认；读完即清，避免后续任何一次搜索页加载再命中 */
  function consumeSearchOpenIntent() {
    var v = null;
    try { v = w.sessionStorage.getItem(OPEN_KEY); } catch (e) {}
    clearSearchOpenIntent();
    if (!v) return false;
    var t = parseInt(v, 10);
    if (!t) return false;
    return (+new Date()) - t < 10000;
  }

  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (!t.closest(SEL.searchIcon)) return;
    markSearchOpenIntent();
  }, true);

  /* S3 search_submit */
  function initSearchSubmit() {
    /* 抽屉里提交：只记 query_id 与来源方式，事件留到结果页统一发。
       ⚠️ 上一版这里发一条、结果页再发一条，同一次搜索翻倍且两条 query_id 不同。 */
    d.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!form || !form.matches || !form.matches(SEL.searchForm)) return;
      var input = form.querySelector('input[name="q"]');
      var term = input ? String(input.value || '').trim() : '';
      if (!term) return;
      if (!searchState.queryId) newQueryId();
      /* 表格枚举：search_method=enter|button|keyword_suggestion。
         submit 事件本身分不出回车还是点按钮，用 submitter 判定。 */
      var m = searchState.method;
      if (!m) {
        var sb = evt.submitter || d.activeElement;
        m = (sb && sb.matches && sb.matches('button, [type="submit"], [role="button"]')) ? 'button' : 'enter';
      }
      searchState.method = m;
      stashQueryId(term, m);
    }, true);

    /* 结果页是唯一的上报点：Liquid 给出确定总数，口径最可靠 */
    var meta = DL.ctx.search;
    if (!meta || !meta.term) return;

    var term = String(meta.term);

    /* ⚠️ 表格口径是「每 query_id 一次」，不是「每会话每个词一次」。
       qid 必须先确定：上一版把去重卡在 qid 生成之前，同一会话内
       重复搜同一个词时 S3/S4/S5 全部跳过，而 S6/S7 仍带着一个
       全新的孤儿 qid 照发，GA4 里出现一批串不上任何搜索的曝光。
       改成按 qid 去重后：换一次搜索就是新 qid，重复搜同词也能正常计数；
       而刷新、翻页、改筛选沿用同一个 qid，不会重复计数。 */
    var stashed = null;
    try { stashed = JSON.parse(w.sessionStorage.getItem(QID_KEY) || 'null'); } catch (e) {}
    var qid = adoptQueryId(term) || newQueryId();
    clearStashedQueryId();
    if (!DL.onceSession('search_submit|' + qid)) return;
    var safe = DL.sanitize(term);
    var method = searchState.method ||
                 (stashed && stashed.term === term ? stashed.method : null) || 'enter';

    /**
     * ⚠️ 规则：search 必须在「搜索响应成功、结果总数明确」之后发送。
     *    上一版直接写 Number(meta.results_count) === 0 ——
     *    当 results_count 缺失（模板未渲染 / 结果由应用运行时注入）时，
     *    Number(null|undefined|'') 全都等于 0，一个有 12 条结果的页面
     *    会被判成「无结果」。线上实测踩过这个坑。
     *    改成：总数不确定就不猜，等结果容器计数稳定后再发。
     */
    function emitSearchTrio(count) {
      DL.push('search_submit', base(C.siteSearch, {
        search_method: method,
        search_term_sanitized: safe,
        results_count: count,
        query_id: qid
      }));
      DL.push('view_search_results', base(C.results, {
        query_id: qid,
        search_term_sanitized: safe,
        results_count: count,
        current_filters: '',
        current_sort: ''
      }));
      if (count === 0) {
        DL.push('search_no_results', base(C.results, {
          query_id: qid,
          search_term_sanitized: safe,
          search_method: method,
          results_count: 0
        }));
      }
    }

    var raw = meta.results_count;
    if (raw !== null && raw !== undefined && raw !== '' && !isNaN(Number(raw))) {
      emitSearchTrio(Number(raw));
      return;
    }

    /* 兜底：连续两次计数一致才算稳定，最多等 8 秒 */
    var last = -1, same = 0, waited = 0;
    (function settle() {
      var n = pageResultCards().length;
      if (n === last) same += 1; else { same = 0; last = n; }
      waited += 500;
      if (same >= 2 || waited >= 8000) { emitSearchTrio(last < 0 ? 0 : last); return; }
      w.setTimeout(settle, 500);
    })();
  }

  /* ================================================================ */
  /* S6 / S7 · 搜索结果页（独立 DOM，抽屉那套在这里全部 0 命中）        */
  /* ================================================================ */

  function pageResultCards() {
    var wrap = d.querySelector(SEL.pageResults);
    if (!wrap) return [];
    return all(wrap, SEL.pageCard).filter(function (c) {
      return c.querySelector('a[href*="/products/"]');
    });
  }

  function pageCardItem(card, index) {
    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var handle = (String(href).match(/\/products\/([^/?#]+)/) || [])[1] || '';
    /* ⚠️ 数字 product id 就挂在卡片根元素上（product-card.liquid:31），
       而 querySelector 只查后代、不含元素自身 —— 上一版正好漏掉最可靠的那个，
       只能靠后代的 card-quick-view-button 兜底；一旦后台把「快速查看」关掉
       （quick_view_visbilty 的合法取值之一），结果页 S6/S7 会静默变成 0 事件。 */
    var pid = (card.getAttribute && card.getAttribute('data-product-id')) || '';
    if (!pid) {
      var idEl = card.querySelector('[data-product-id]');
      pid = idEl ? idEl.getAttribute('data-product-id') : '';
    }
    /* ⚠️ 不能回退成 handle：全站其它地方（collection / home / pdp）的 item_id
       一律是数字 product id，混入 handle 会让同一台商品在 GA4 里裂成两个 item，
       浏览→加购→购买的漏斗断裂。取不到就不发这条 item。 */
    if (!pid) return null;
    return DL.item(pid, {
      index: index,
      item_list_id: 'search_results',
      item_list_name: 'Search Results',
      item_name: txt(card.querySelector('[class*="title"], h3, h2')) || undefined
    });
  }

  function initSearchResultsPage() {
    if (DL.ctx.page_type !== 'search') return;
    if (!d.querySelector(SEL.pageResults)) return;

    /* ⚠️ 不能把容器存进闭包：搜索页 enable_filtering / enable_sorting 都是 true，
       facets.js:226 的 renderProductGridContainer() 是
       document.querySelector('[data-section_id]').innerHTML = …，
       容器元素本身会被销毁重建。闭包里的引用会变成游离节点，
       筛选或排序一次之后 select_item 永久失效、曝光也一起失效。 */
    function wrapNow() { return d.querySelector(SEL.pageResults); }

    /* S6 结果商品曝光。筛选/排序/加载更多都会换内容 → 重新观察一批。 */
    var pageBatch = 0;
    var stopPageObserve = null;

    function observeBatch(trigger) {
      var wrap = wrapNow();
      if (!wrap) return;
      var list = pageResultCards();
      if (!list.length) return;
      pageBatch += 1;
      var thisBatch = pageBatch;
      if (stopPageObserve) { try { stopPageObserve(); } catch (e) {} stopPageObserve = null; }
      stopPageObserve = DL.observe(wrap, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        var now = pageResultCards();
        if (!now.length) return;
        if (!DL.once('view_item_list|search_results|' + thisBatch)) return;
        var items = now.map(function (c, i) { return pageCardItem(c, i + 1); }).filter(Boolean);
        if (!items.length) return;
        DL.push('view_item_list', base(C.resultGrid, {
          item_list_id: 'search_results',
          item_list_name: 'Search Results',
          query_id: searchState.queryId,
          list_batch_index: thisBatch,
          trigger_source: trigger,
          current_filters: '',
          current_sort: '',
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed,
          items: items
        }));
      });
    }

    observeBatch('initial');

    /* ⚠️ pagination_type = load-more、每页 12 条而实测结果有 39 条：
       只发一次的话后 27 条（69%）零曝光，而 select_item 照发，点击率分母偏小。
       监听结果集变化，换一批就重新观察一批。 */
    (function watchPageResults() {
      var sig = pageResultCards().length;
      var settle = null;
      try {
        new MutationObserver(function () {
          if (settle) w.clearTimeout(settle);
          settle = w.setTimeout(function () {
            var now = pageResultCards().length;
            if (now === sig || !now) return;
            var grew = now > sig;
            sig = now;
            observeBatch(grew ? 'load_more' : 'filter');
          }, 400);
        }).observe(d.body, { childList: true, subtree: true });
      } catch (e) {}
    })();

    /* S7 结果商品点击 */
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var card = t.closest(SEL.pageCard);
      if (!card || !card.closest(SEL.pageResults)) return;   /* 实时判归属，不用闭包 */
      /* ⚠️ 只有真的点在商品链接上才算 select_item。
         settings 里 quick_view_visbilty=always，商品卡上还有一个「快速查看」按钮，
         它在商品链接 </a> 之外；回退到 card.querySelector 会把它也记成进入 PDP，
         而用户根本没离开列表页。 */
      var link = t.closest('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      var pos = pageResultCards().indexOf(card);
      var index = pos > -1 ? pos + 1 : undefined;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link);
        if (!__np) return;
        var item = pageCardItem(card, index);
        if (!item) return;
        __np('select_item', base(C.resultGrid, {
          item_list_id: 'search_results',
          item_list_name: 'Search Results',
          query_id: searchState.queryId,
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
    }, true);
  }

  /* H1-07 view_cart */
  function initViewCart() {
    var drawer = d.querySelector(SEL.cartDrawer);
    if (!drawer) return;
    var opened = drawer.hasAttribute('drawer-open');
    var mo = new MutationObserver(function () {
      var isOpen = drawer.hasAttribute('drawer-open') || drawer.classList.contains('drawer-open');
      if (isOpen && !opened) {
        opened = true;
        w.setTimeout(function () {
          DL.fetchCart().then(function (cart) {
            if (!cart) return;
            DL.push('view_cart', base(C.cart, {
              cart_type: cartType(),
              item_count: cart.item_count,
              value: DL.money(cart.total_price),
              items: DL.itemsFromCartLines(cart.items, {
                item_list_id: 'cart_drawer',
                item_list_name: 'Cart Drawer'
              })
            }));
          });
        }, 150);
      } else if (!isOpen) {
        opened = false;
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['drawer-open', 'class'] });
  }

  /* H1-08 begin_checkout desde el carrito (página /cart + cajón lateral).
     El PDP ya emite begin_checkout desde el área de compra / sticky / pago dinámico; aquí cubrimos
     los DEMÁS puntos de "ir a pagar": el botón "Finalizar compra" de /cart y el enlace de checkout
     del cajón. Se mantiene el carrito en caché (carga + cart:updated) para poder enviar el evento de
     forma SÍNCRONA antes de que el clic navegue a /checkout (igual criterio que begin_checkout del PDP). */
  function initCartCheckout() {
    var cartCache = null;
    function refresh() { try { DL.fetchCart().then(function (c) { if (c && c.items) cartCache = c; }); } catch (e) {} }
    refresh();
    d.addEventListener('cart:updated', function (e) {
      if (e && e.detail && e.detail.cartData && e.detail.cartData.items) cartCache = e.detail.cartData;
      else refresh();
    });
    var lastSent = 0;
    d.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t.closest && t.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], a[href*="/cart/checkout"]');
      if (!btn) return;
      /* Excluir lo que YA cubre el tracking del PDP: pago dinámico (Shop Pay) y el área de compra
         principal / sticky del producto (allí begin_checkout se emite con su propio contexto). */
      if (btn.closest('.shopify-payment-button, product-info, [id^="MainProduct"], .dji-sticky-atc, [class*="sticky-atc"]')) return;
      if (Date.now() - lastSent < 2000) return;             /* anti doble clic */
      lastSent = Date.now();
      var inDrawer = !!(btn.closest && btn.closest(SEL.cartDrawer));
      var cfg = inDrawer
        ? { component_id: 'cart_drawer_checkout', placement: 'cart_drawer' }
        : { component_id: 'cart_page_checkout', placement: 'cart' };
      DL.afterTick(function () {
        if (!DL.isInteractive(btn)) return;
        var extra = { element_id: 'begin_checkout', checkout_method: 'standard', cart_type: inDrawer ? 'drawer' : 'page' };
        var cart = cartCache;
        if (cart && cart.items) {
          extra.item_count = cart.item_count;
          extra.value = DL.money(cart.total_price);
          extra.items = DL.itemsFromCartLines(cart.items, { item_list_id: 'cart', item_list_name: 'Cart' });
        }
        DL.push('begin_checkout', base(cfg, extra));
      });
    }, true);
  }

  /* H1-09 · Barra de anuncios (app de terceros <single-banner> con shadow DOM).
     No es un <a>; la app navega por JS al hacer clic (p. ej. a la página de campaña). Rastreamos
     view_promotion (cuando la barra se ve) y select_promotion (clic). El evento de clic es compuesto,
     así que a nivel document e.target queda re-apuntado al host <single-banner>. Como no hay href,
     no se usa navPush: se envía de inmediato en afterTick, antes de que la app navegue. */
  function initAnnouncementBar() {
    var CFG = { component_id: 'announcement_bar', placement: 'announcement_bar' };
    var SEL_BAR = 'single-banner, [bss-banner], [banner_id]';
    function host() { return d.querySelector(SEL_BAR); }
    function promoId(h) { var id = h && h.getAttribute('banner_id'); return id ? 'announcement_bar_' + id : 'announcement_bar'; }
    function promoName(h) {
      /* el texto vive en shadow DOM anidado; se recorre hasta .banner-content-wrapper */
      try {
        function find(node, depth) {
          if (!node || depth > 6) return '';
          var sr = node.shadowRoot;
          if (sr) {
            var cw = sr.querySelector('.banner-content-wrapper, [class*="content-wrapper"]');
            if (cw && (cw.innerText || '').trim()) return cw.innerText.replace(/\s+/g, ' ').trim().slice(0, 120);
            var inner = [].slice.call(sr.querySelectorAll('*')).filter(function (x) { return x.shadowRoot; });
            for (var i = 0; i < inner.length; i++) { var r = find(inner[i], depth + 1); if (r) return r; }
          }
          return '';
        }
        return find(h, 0);
      } catch (e) { return ''; }
    }

    /* view_promotion: la barra la inyecta la app de forma asíncrona → sondeo hasta ~12s. */
    var tries = 0;
    (function pollView() {
      var h = host();
      if (h) {
        if (DL.once('view_promotion|' + promoId(h))) {
          DL.push('view_promotion', base(CFG, {
            promotion_id: promoId(h),
            promotion_name: promoName(h) || undefined,
            creative_slot: 'announcement_bar'
          }));
        }
        return;
      }
      if (++tries < 40) w.setTimeout(pollView, 300);
    })();

    /* select_promotion: clic en la barra. Delegado en document (captura) para no depender del shadow. */
    d.addEventListener('click', function (e) {
      var h = e.target && e.target.closest && e.target.closest(SEL_BAR);
      if (!h) return;
      DL.afterTick(function () {
        DL.push('select_promotion', base(CFG, {
          promotion_id: promoId(h),
          promotion_name: promoName(h) || undefined,
          element_id: 'announcement_bar',
          creative_slot: 'announcement_bar'
        }));
      });
    }, true);
  }

  function start() {
    initNavMenuOpen();
    initSearchOpen();
    initSearchSubmit();
    initSearchResultsPage();
    initViewCart();
    initCartCheckout();
    initAnnouncementBar();
    var p = popup();
    if (p) watchResults(p);
    DL.log('header tracking ready', DL.ctx.page_type);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
